import { render } from "./hidedesktop.vue?vue&type=template&id=ac15647c&scoped=true"
import script from "./hidedesktop.vue?vue&type=script&lang=js"
export * from "./hidedesktop.vue?vue&type=script&lang=js"

import "./hidedesktop.vue?vue&type=style&index=0&id=ac15647c&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac15647c"]])

export default __exports__